"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultValue_1 = require("./defaultValue");
var fixDateFormat_1 = require("./fixDateFormat");
var dataValue_1 = require("./dataValue");
var schemaValue_1 = require("./schemaValue");
var validate_1 = require("./validate");
var compareData_1 = require("./compareData");
var clearData_1 = require("./clearData");
var setData_1 = require("./setData");
var fixAndMergeSchema_1 = require("./fixAndMergeSchema");
var flatPropsList_1 = require("./flatPropsList");
var JSchema = /** @class */ (function () {
    function JSchema(schema) {
        this.schema = {};
        // this.schema={};
        if (schema) {
            this.init(schema);
        }
    }
    /**
     * ładowanie schema
     *
     * @param {(string | JSONSchema | (string | JSONSchema)[])} schema schemat lub tablica schematów
     * @memberof JSchema
     */
    JSchema.prototype.init = function (schema) {
        var schemaList = [];
        if (Array.isArray(schema)) {
            for (var _i = 0, schema_1 = schema; _i < schema_1.length; _i++) {
                var schemaItem = schema_1[_i];
                if (typeof schemaItem === 'string') {
                    schemaList.push(JSON.parse(schemaItem));
                }
                else {
                    schemaList.push(schemaItem);
                }
            }
        }
        else if (typeof schema === 'string') {
            schemaList.push(JSON.parse(schema));
        }
        else {
            schemaList.push(schema);
        }
        this.schema = fixAndMergeSchema_1.default(schemaList);
    };
    /**
     * Domyślna wartośc na podstawie pól default ze schematu
     * @param schemaPath Ściezka schematu dla ktorej zwrocic domyslan wartosc, gdy pominieta zwraca dla pelnego schematu
     */
    /**
     * Domyślna wartośc na podstawie pól default ze schematu
     *
     * @param {boolean} [force] mimo braku ustawienia default ustawia domyślne wartości w zależności od typu
     * @param {string} [schemaPath] ścieżka schematu
     * @returns {*}
     * @memberof JSchema
     */
    JSchema.prototype.defaultValue = function (force, schemaPath) {
        var schema = schemaPath ? this.schemaValue(schemaPath) : this.schema;
        if (schema) {
            return defaultValue_1.default(schema, force);
        }
        return null;
    };
    /**
     * Zwraca wartosc pola danych wg sciezki
     *
     * @param {*} data Pelne dane
     * @param {string} path sciezka w formacie pole.tablica[0].pole2
     * @returns {*} dane zgodne ze schematem
     * @memberof JSchema
     */
    JSchema.prototype.dataValue = function (data, path) {
        return dataValue_1.default(this.schema, data, path);
    };
    /**
     * Zwraca czesc schematu na podstawie sciezki
     * @param path sciezka w formacie pole.tablica[0].pole2
     */
    JSchema.prototype.schemaValue = function (path) {
        return schemaValue_1.default(this.schema, path);
    };
    /**
     * Sprawdza poprawnoc danych według schematu i zawartej w nim walidacji
     * @param data dane do sprawdzenia
     * @param schema gałąź schamtu, gdy pominięto to uzywa glownej
     * @param path sciezka schamtu, gdy pusta uzywa glownej
     */
    JSchema.prototype.validate = function (data, options, schema, path) {
        if (schema === void 0) { schema = null; }
        if (path === void 0) { path = ''; }
        var result = validate_1.default(schema || this.schema, data, options, path || '');
        if (result.errors.length) {
            result.valid = false;
        }
        return result;
    };
    /**
     * Porównuje dane uzywając schematu, zwraca CompareResult zawierający wynik porównania i listę róźnic
     * @param firstItem pierwszy element do porównania
     * @param secondItem drugi element do porównania
     */
    JSchema.prototype.compareData = function (firstItem, secondItem, compareArraySize) {
        return compareData_1.default(this.schema, firstItem, secondItem);
    };
    /**
     * Czyści dane pozostawiając tylko te zgodne ze schematem
     *
     * @param {*} data dane do wyczyszczenia
     * @param {boolean} [checkDataType] czy sprawdzac poprawnośc typów danych prostych
     * (number,integer,boolean, string), domyślnie nie
     * @returns {*} wyczyszczone dane
     * @memberof JSchema
     */
    JSchema.prototype.clearData = function (data, checkDataType) {
        return clearData_1.default(data, this.schema, checkDataType);
    };
    /**
     * ustawienie danych zgodnie ze schematem
     *
     * @param {*} data obiekt reprezentujący dane docelowe
     * @param {*} value dane do zapisu
     * @param {string} path ścieżka
     * @param {*} [Vue] konstruktor Vue
     * @returns {boolean} czy udało się ustawić
     * @memberof JSchema
     */
    JSchema.prototype.setData = function (data, value, path, Vue) {
        return setData_1.default(this.schema, data, value, path, 0, Vue);
    };
    /**
     * Naprawia formaty danych typu date i date-time oraz string
     *
     * @param {*} data dane
     * @param {*} [Vue] konstruktor Vue
     * @returns {number} ile pól naprawino
     * @memberof JSchema
     */
    JSchema.prototype.fixDateFormat = function (data, Vue) {
        return fixDateFormat_1.default(this.schema, data, Vue);
    };
    JSchema.prototype.fixFormat = function (data, Vue) {
        return fixDateFormat_1.default(this.schema, data, Vue);
    };
    /**
     * zwraca płaską listę elementów schematu
     *
     * @param {boolean} [simpleTypesOnly=false] zy zwracać tylko typy proste (pomija object i array)
     * @returns {FlatPropsListItem[]} lista zwróconych właściwości
     * @memberof JSchema
     */
    JSchema.prototype.flatPropsList = function (simpleTypesOnly) {
        if (simpleTypesOnly === void 0) { simpleTypesOnly = false; }
        return flatPropsList_1.default(this.schema, simpleTypesOnly);
    };
    return JSchema;
}());
exports.default = JSchema;
//# sourceMappingURL=JSchema.js.map